import styled from 'styled-components';

export const Icon = styled.span<{ isOther?: boolean; name: string }>`
  /* stylelint-disable font-family-no-missing-generic-family-keyword*/
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: ${props =>
    props.isOther ? 'styled-react-icons-other' : 'styled-react-icons'} !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  &:before {
    content: ${props =>
      props.isOther ? props.theme.icons.other[props.name] : props.theme.icons[props.name]};
  }
`;

export default Icon;
